import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { dramas } from '@/mocks/dramas';
import type { Drama } from '@/types';
import DramaCard from '@/components/base/DramaCard';
import SectionHeading from '@/components/base/SectionHeading';

const INITIAL = 10;
const STEP = 4;

export default function LatestDramas() {
  const sorted = useMemo(
    () =>
      [...(dramas as Drama[])].sort((a, b) =>
        a.updateTime < b.updateTime ? 1 : -1,
      ),
    [],
  );
  const [count, setCount] = useState(INITIAL);

  const visible = sorted.slice(0, count);
  const hasMore = count < sorted.length;

  return (
    <section className="bg-background-50 px-4 py-12 md:px-8 md:py-14 lg:px-12">
      <SectionHeading
        eyebrow="Latest"
        title="最新影视剧推荐"
        description="按更新时间为你精选近期上线的电视剧与电影，快速了解剧情与演员阵容。"
        action={
          <Link
            to="/category/tv"
            className="inline-flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            全部影视
            <i className="ri-arrow-right-line"></i>
          </Link>
        }
      />

      <div className="grid grid-cols-2 gap-x-4 gap-y-6 sm:grid-cols-3 lg:grid-cols-5">
        {visible.map((drama) => (
          <DramaCard key={drama.id} drama={drama} />
        ))}
      </div>

      {hasMore && (
        <div className="mt-10 flex justify-center">
          <button
            type="button"
            onClick={() => setCount((prev) => Math.min(prev + STEP, sorted.length))}
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-6 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            <i className="ri-add-line"></i>
            加载更多
          </button>
        </div>
      )}
    </section>
  );
}